module.exports = __webpack_public_path__ + "img/1491804404.bc8a59f5.jpg";